import { Routes } from '@angular/router';
import { AuthGuard } from '../core/guards/auth.guard';
import { GestionnaireOrAnimateurGuard } from '../core/guards/gestionnaire-or-animateur.guard';
import { AnimateurGuard } from '../core/guards/animateur.guard';
import { RoleGuard } from '../core/guards/role.guard';
import { ModuleGuard } from '../core/guards/module.guard';
import { ROLES } from '../core/constants/roles.constants';
import { APP_MODULES } from '../core/constants/app-modules.constants';

export const PLANNING_ROUTES: Routes = [
  {
    path: 'planning/list',
    loadComponent: () => import('../features/planning/list/list.component').then(m => m.PlanningListComponent),
    canActivate: [AuthGuard, GestionnaireOrAnimateurGuard, ModuleGuard],
    data: { modules: [APP_MODULES.AGENDA] }
  },
  {
    path: 'planning-externes/list',
    loadComponent: () =>
      import('../features/planning-externes/list/list.component').then(m => m.PlanningExternesListComponent),
    canActivate: [AuthGuard, RoleGuard, ModuleGuard],
    data: {
      roles: [ROLES.PODOLOGUE, ROLES.COIFFEUR],
      modules: [APP_MODULES.AGENDA]
    },
  },
  {
    path: 'menus/list',
    loadComponent: () => import('../features/menus/list/list.component').then(m => m.MenusListComponent),
    canActivate: [AuthGuard, AnimateurGuard, ModuleGuard],
    data: { modules: [APP_MODULES.MENUS] }
  },
  {
    path: 'menus/add',
    loadComponent: () => import('../features/menus/add/add.component').then(m => m.MenuAddComponent),
    canActivate: [AuthGuard, AnimateurGuard, ModuleGuard],
    data: { modules: [APP_MODULES.MENUS] }
  },
  {
    path: 'menus/edit/:id',
    loadComponent: () => import('../features/menus/edit/edit.component').then(m => m.MenuEditComponent),
    canActivate: [AuthGuard, AnimateurGuard, ModuleGuard],
    data: { modules: [APP_MODULES.MENUS] }
  },
  {
    path: 'activities/list',
    loadComponent: () => import('../features/activities/list/list.component').then(m => m.ActivitiesListComponent),
    canActivate: [AuthGuard, AnimateurGuard, ModuleGuard],
    data: { modules: [APP_MODULES.ACTIVITES] }
  },
  {
    path: 'animateur/exercices/assignes',
    loadComponent: () =>
      import('../features/animateur/exercices-assignes/exercices-assignes.component').then(
        m => m.AnimateurExercicesAssignesComponent
      ),
    canActivate: [AuthGuard, AnimateurGuard],
  },
];
